import React, { useRef, useState } from 'react'
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Magnetic component adds a delightful attraction effect to its children
 * when the mouse hovers near them.
 */
export default function Magnetic({ children, className = "" }) {
    const ref = useRef(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const shouldReduceMotion = useReducedMotion();

    const handleMouse = (e) => {
        if (shouldReduceMotion) return;

        const { clientX, clientY } = e;
        if (!ref.current) return;

        const { height, width, left, top } = ref.current.getBoundingClientRect();
        const middleX = clientX - (left + width / 2);
        const middleY = clientY - (top + height / 2);

        // Adjust the strength of the magnetic pull (0.2 is a good balance)
        setPosition({ x: middleX * 0.2, y: middleY * 0.2 });
    };

    const reset = () => {
        setPosition({ x: 0, y: 0 });
    };

    const { x, y } = position;

    return (
        <motion.div
            className={className}
            style={{ position: "relative" }}
            ref={ref}
            onMouseMove={handleMouse}
            onMouseLeave={reset}
            animate={shouldReduceMotion ? { x: 0, y: 0 } : { x, y }}
            transition={{ type: "spring", stiffness: 150, damping: 15, mass: 0.1 }}
        >
            {children}
        </motion.div>
    );
}
